/**
 *
 * Video Block
 *
 * Handling video lightbox
 */

(function (window, $ ) {

jQuery(document).ready(function () {


    try{
        jQuery(".fancybox").fancybox({
            type: "iframe", //<--added
            maxWidth: 800,
            maxHeight: 600,
            fitToView: false,
            width: '70%',
            height: '70%',
            autoSize: false,
            closeClick: false,
            openEffect: 'none',
            closeEffect: 'none'
        })
    }catch(e){
        console.log( e );
    }


});

})( window, jQuery );